














import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { Performer } from '@/types/performer';

@Component({
  components: {
    Performer: () => import('@/components/Performer.vue'),
  },
})
export default class PerformanceArea extends Vue {
  @Prop()
  private performerList: Performer[] | undefined;
}
